(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
      const backToTopButton = document.getElementById('back-to-top');
      if (!backToTopButton) return;

      const threshold = parseInt(backToTopButton.style.getPropertyValue('--back-to-top-threshold')) || 300;

      const toggleButton = function() {
        if (window.scrollY >= threshold) {
          backToTopButton.classList.add('visible');
        } else {
          backToTopButton.classList.remove('visible');
        }
      };

      const scrollToTop = function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      };

      window.addEventListener('scroll', toggleButton);
      backToTopButton.addEventListener('click', scrollToTop);

      toggleButton();
    });
  } catch(e) { console.error(e); }
})();

})();
